// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FT2b","rootMobile":"styles_rootMobile__1Xaln"};